<template>
  <div>
    <v-text-field v-model="value.email" :label="$t('objects.person.emails.email') + ' *'" :rules="emailRule" outlined />
    <v-autocomplete
      v-model="value.label"
      :items="Object.values(PersonLabelEnum)"
      :label="$t('objects.person.emails.label')"
      auto-select-first
      outlined
    >
      <template #item="{ item }">
        {{ $t(`enums.PersonLabelEnum.${item}`) }}
      </template>
      <template #selection="{ item }">
        {{ $t(`enums.PersonLabelEnum.${item}`) }}
      </template>
    </v-autocomplete>
    <v-textarea v-model="value.notes" :label="$t('objects.person.emails.notes')" auto-select-first outlined multiple />

    <debug>
      {{ value }}
    </debug>
  </div>
</template>

<script lang="ts">
import { PersonLabelEnum } from "@/lib/enum/person-label.enum";
import { emailRule } from "@/lib/rules/contactRule";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IPersonEmail } from "@/models/person-email.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: { Debug },
  filters: {}
})
export default class PersonEmailForm extends mixins(RulesMixin) {
  readonly PersonLabelEnum = PersonLabelEnum;

  @Prop()
  value!: IPersonEmail;

  get emailRule() {
    return [emailRule()];
  }
}
</script>
